import React from 'react';

interface OfficeIconProps {
  size?: number;
  color?: string;
}

const OfficeIcon: React.FC<OfficeIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_186_747)">
        <path
          d="M1.10071 12.2458C1.10071 12.9495 1.38028 13.6245 1.87792 14.1221C2.37556 14.6198 3.05051 14.8994 3.75428 14.8994C4.45805 14.8994 5.133 14.6198 5.63064 14.1221C6.12828 13.6245 6.40785 12.9495 6.40785 12.2458L3.75428 5.68616L1.10071 12.2458ZM6.40785 12.2458H1.10071"
          stroke={color}
          strokeWidth="1.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.59213 7.99993C9.59213 8.7037 9.8717 9.37865 10.3693 9.87629C10.867 10.3739 11.542 10.6535 12.2457 10.6535C12.9494 10.6535 13.6244 10.3739 14.1221 9.87629C14.6197 9.37865 14.8993 8.7037 14.8993 7.99993L12.2457 1.82242L9.59213 7.99993ZM14.8993 7.99993H9.59213"
          stroke={color}
          strokeWidth="1.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.16214 6.40785L13.8379 1.10071"
          stroke={color}
          strokeWidth="1.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 3.75428V1.10071"
          stroke={color}
          strokeWidth="1.14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_186_747">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OfficeIcon;
